import MenuItem from './MenuItem.js';

/**
 * SubMenuItem component
 */
export default class SubMenuItem extends MenuItem {
  /**
   * Component Configuration
   */
  static config = {
    name: 'SubMenuItem',
    refs: ['submenu', 'link[]', 'back', 'aim'],
  };

  /**
   *
   */
  open() {
    super.open();
    document.body.classList.add('is-last-menu-open');
  }

  /**
   *
   */
  close() {
    super.close();
    document.body.classList.remove('is-last-menu-open');
  }
}
